import gql from "graphql-tag";

export const GET_ORDERS = gql`
  query GetOrders {
    customer {
      id
      orders {
        nodes {
          id
          databaseId
          date
          status
          total
          subtotal
          shippingTotal
          paymentMethod
          lineItems {
            nodes {
              quantity
              total
              product {
                node {
                  id
                  name
                  image {
                    id
                    sourceUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ORDER = gql`
  query GetOrderDetail {
    customer {
      id
      orders {
        nodes {
          id
          databaseId
          status
          total
          subtotal
          shippingTotal
          paymentMethod
          lineItems {
            nodes {
              quantity
              total
              product {
                node {
                  id
                  name
                  ... on SimpleProduct { price }
                  ... on VariableProduct { price }
                  image {
                    id
                    sourceUrl
                    mediaItemUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    customer {
      id
      firstName
      lastName
      email
    }
  }
`;
